import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

class ProductionPlanProvider extends HttpRequest {
  constructor () {
    super(process.env.VUE_APP_MER_API)
  }

  getWorkflow () {
    this.setHeader(getAuthToken())
    return this.get('/production-plan/workflow')
  }

  getCollectionsOverview (query) {
    this.setHeader(getAuthToken())
    return this.get('/collections/overview', query)
  }

  createWorkflow (payload) {
    this.setHeader(getAuthToken())
    return this.post('/production-plan/workflow', payload)
  }

  updateWorkflow (id, payload) {
    this.setHeader(getAuthToken())
    return this.put(`/production-plan/workflow/${id}`, payload)
  }

  removeStage (payload) {
    this.setHeader(getAuthToken())
    return this.delete('/production-plan/workflow/stages', payload)
  }

  getCollectionPlaning (payload) {
    this.setHeader(getAuthToken())
    return this.get('/production-plan/planing/collection', payload)
  }

  getPrototypeTasks (prototypeId) {
    this.setHeader(getAuthToken())
    return this.get(`/production-plan/planing/prototype-tasks/${prototypeId}`)
  }

  assignTimeline (payload) {
    this.setHeader(getAuthToken())
    return this.post('/production-plan/planing/assign-timeline', payload)
  }

  updateTaskDate (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/production-plan/planing/task-date', payload)
  }

  bulkUpdateTaskDate (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/production-plan/planing/bulk-task-date', payload)
  }

  batchUpdateTaskDate (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/production-plan/planing/batch-task-date', payload)
  }

  updateTaskStatus (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/production-plan/planing/task-status', payload)
  }

  changeCollectionSalesDate (payload) {
    this.setHeader(getAuthToken())
    return this.patch('/production-plan/planing/change-collection-sales-date', payload)
  }

  getTaskLogs (query) {
    this.setHeader(getAuthToken())
    return this.get('/production-plan/task-log', query)
  }

  getTaskLogSummary (query) {
    this.setHeader(getAuthToken())
    return this.get('/production-plan/task-log/summary', query)
  }

  getCompletionRate (year) {
    this.setHeader(getAuthToken())
    return this.get(`/production-plan/my-completion-rate/completion-rate?year=${year}`)
  }

  getTaskStatus (year) {
    this.setHeader(getAuthToken())
    return this.get(`/production-plan/my-completion-rate/task-summary?year=${year}`)
  }

  getCalendarEvents (query) {
    this.setHeader(getAuthToken())
    return this.get('/production-plan/calendar/event', query)
  }

  createCalendarEvent (payload) {
    this.setHeader(getAuthToken())
    return this.post('/production-plan/calendar/event', payload)
  }

  updateCalendarEvent (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/production-plan/calendar/event/${id}`, payload)
  }

  deleteCalendarEvent (id) {
    this.setHeader(getAuthToken())
    return this.remove(`/production-plan/calendar/event/${id}`)
  }

  getDayOff (query) {
    this.setHeader(getAuthToken())
    return this.get('/production-plan/day-off', query)
  }

  getCustomFields (query) {
    this.setHeader(getAuthToken())
    return this.get('/production-plan/custom-field', query)
  }

  createCustomField (payload) {
    this.setHeader(getAuthToken())
    return this.post('/production-plan/custom-field', payload)
  }

  updateCustomField (id, payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/production-plan/custom-field/${id}`, payload)
  }

  deleteCustomField (id) {
    this.setHeader(getAuthToken())
    return this.remove(`/production-plan/custom-field/${id}`)
  }
}

export default ProductionPlanProvider
